import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var analyticsPluginKey = new PluginKey('analyticsPlugin');